import React, { Component } from "react";
import { Slider } from "antd";
import Utils from "@/utils";
import moment from "moment";
import sentGAEvent from "@/ga";
import { ReactComponent as PlayIcon } from "@/assets/icons/play.svg";
import { ReactComponent as PauseIcon } from "@/assets/icons/pause.svg";

import "@/assets/audioJoiner.less";

import AudioJoinerWorkListItemFunction from "./children/AudioJoinerWorkListItemFunction";
import TipsModalSimple from "@/components/common/tipSimpleModal/TipSimpleModal";

class AudioJoinerWorkContentFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      audioAccept: ".wav,.mp3,.m4a,.aac,.ogg",
      workPlaceVisible: true,
      duration: "00:00.00",
      currentTime: "00:00.00",
      currentTimePercent: 0,
      playing: false,
      start: "00:00.00",
      end: "00:00.00",
      selectedIndex: 0,
      mergeDuration: 0,
    };
  }

  handleSliderTips = value => {
    const d = Utils.getSeconds(this.state.duration);
    return moment("00:00:00", "mm:ss:SS")
      .add((d * value) / 100, "seconds")
      .format("mm:ss:SS")
      .replace(/:([^:]*)$/, ".$1");
  };

  play = isPlayStartTime => {
    this.setState({ playing: true });
    const audioJoinerList = [...this.props.audioJoinerList];
    const { selectedIndex } = this.state;
    if (isPlayStartTime) {
      console.log("这很难改上十多个", selectedIndex);
      audioJoinerList[selectedIndex].wavesurfer.setCurrentTime(Utils.getSeconds(audioJoinerList[selectedIndex].start));
      audioJoinerList[selectedIndex].wavesurfer.play(
        Utils.getSeconds(audioJoinerList[selectedIndex].start),
        Utils.getSeconds(audioJoinerList[selectedIndex].end)
      );
    } else if (
      audioJoinerList[selectedIndex].wavesurfer.getCurrentTime() >= Utils.getSeconds(audioJoinerList[selectedIndex].start) &&
      audioJoinerList[selectedIndex].wavesurfer.getCurrentTime() <= Utils.getSeconds(audioJoinerList[selectedIndex].end)
    ) {
      audioJoinerList[selectedIndex].wavesurfer.play(
        audioJoinerList[selectedIndex].wavesurfer.getCurrentTime(),
        Utils.getSeconds(audioJoinerList[selectedIndex].end)
      );
    } else {
      audioJoinerList[selectedIndex].wavesurfer.play(
        Utils.getSeconds(audioJoinerList[selectedIndex].start),
        Utils.getSeconds(audioJoinerList[selectedIndex].end)
      );
    }
  };

  pause = () => {
    this.handlePauseAllAudio();
  };

  tooglePlay = () => {
    if (this.state.playing) {
      this.pause();
    } else {
      this.play();
    }
  };

  handleCurrentTimeChange = value => {
    this.handlePauseAllAudio();
    this.setState({
      currentTimePercent: value,
    });
    this.props.audioJoinerList.forEach((item, index) => {
      if (index === 0 && value < ((Utils.getSeconds(item.end) - Utils.getSeconds(item.start)) / this.state.mergeDuration) * 100) {
        this.setState({ selectedIndex: 0 });
        let currentTime = (value / 100) * this.state.mergeDuration + Utils.getSeconds(item.start);
        item.wavesurfer.setCurrentTime(currentTime);
      } else if (index > 0 && value > (this.getBeforeAudiosDuration(index) / this.state.mergeDuration) * 100) {
        this.setState({ selectedIndex: index });
        let percent = value - (this.getBeforeAudiosDuration(index) / this.state.mergeDuration) * 100;
        let currentTime = (percent / 100) * this.state.mergeDuration + Utils.getSeconds(item.start);
        item.wavesurfer.setCurrentTime(currentTime);
      }
    });
  };

  handleSelected = selectedIndex => {
    if (selectedIndex !== this.state.selectedIndex) {
      this.handlePauseAllAudio();
    }
    this.setState({
      selectedIndex,
    });
  };

  handlePlayFinishCallBack = index => {
    if (index >= this.props.audioJoinerList.length - 1) {
      this.setState({ playing: false });
      return false;
    }
    if (this.props.audioJoinerList[index + 1].wavesurfer && !this.props.audioJoinerList[index + 1].wavesurfer.isPlaying()) {
      this.setState({ selectedIndex: index + 1 }, () => this.play(true));
    }
  };

  handleChangeAudioJoinerList = audioJoinerItem => {
    const audioJoinerList = [...this.state.audioJoinerList];
    audioJoinerList.forEach(item => {
      if (item.guid === audioJoinerItem.guid) {
        item = audioJoinerItem;
      }
    });
    this.setState({
      audioJoinerList,
    });
  };

  handleChangeSort = (e, type, index) => {
    e.stopPropagation();
    console.log(index);
    if ((index === 0 && type === "up") || (index === this.props.audioJoinerList.length - 1 && type === "down")) {
      return false;
    }
    this.setState({
      selectedIndex: type === "up" ? index - 1 : index + 1,
    });
    const audioJoinerList = [...this.props.audioJoinerList];
    let audioItem = audioJoinerList[index];
    if (type === "up") {
      audioJoinerList[index] = { ...audioJoinerList[index - 1], fadeOut: audioJoinerList[index].fadeOut, fadeIn: audioJoinerList[index].fadeIn };
      audioJoinerList[index - 1] = { ...audioItem, fadeOut: audioJoinerList[index - 1].fadeOut, fadeIn: audioJoinerList[index - 1].fadeIn };
    } else if (type === "down") {
      audioJoinerList[index] = { ...audioJoinerList[index + 1], fadeOut: audioJoinerList[index].fadeOut, fadeIn: audioJoinerList[index].fadeIn };
      audioJoinerList[index + 1] = { ...audioItem, fadeOut: audioJoinerList[index + 1].fadeOut, fadeIn: audioJoinerList[index + 1].fadeIn };
    }
    this.props.onAudioJoinerListChange(audioJoinerList);
  };

  handleDeleteAudioJoinerItem = () => {
    sentGAEvent({
      category: "audio_merge_action",
      action: "audio_merge_delete",
    });
    const guid = this.state.deleteGuid;
    let i;
    let audioJoinerList = [...this.props.audioJoinerList];
    audioJoinerList.forEach((item, index) => {
      if (item.guid === guid) {
        i = index;
      }
      if (i && index > i) {
        item.fadeIn = this.props.audioJoinerList[index - 1].fadeIn;
        item.fadeOut = this.props.audioJoinerList[index - 1].fadeOut;
      }
    });
    audioJoinerList = audioJoinerList.filter(item => {
      return item.guid !== guid;
    });
    this.props.onAudioJoinerListChange(audioJoinerList);
    this.setState({ selectedIndex: 0, deleteModal: false });
  };

  getBeforeAudiosDuration = index => {
    let duration = 0;
    for (let i = 0; i < this.props.audioJoinerList.length; i++) {
      if (i < index) {
        duration = duration + Utils.getSeconds(this.props.audioJoinerList[i].end) - Utils.getSeconds(this.props.audioJoinerList[i].start);
      } else {
        break;
      }
    }
    return duration;
  };

  handleCurrentTimeFormItem = (index, precent) => {
    if (this.props.audioJoinerList.length > 1 && index > 0) {
      this.setState({
        currentTimePercent: (this.getBeforeAudiosDuration(index) / this.state.mergeDuration) * 100 + precent,
      });
    } else {
      this.setState({
        currentTimePercent: precent,
      });
    }
  };

  handleMergeAudioDuration = () => {
    let mergeDuration = 0;
    this.props.audioJoinerList.forEach(item => {
      mergeDuration = mergeDuration + (Utils.getSeconds(item.end) - Utils.getSeconds(item.start));
    });
    // if (this.props.audioJoinerList.length > 1) {
    //   mergeDuration = mergeDuration - this.props.audioJoinerList.filter(item => item.fadeOut).length * 3;
    // }
    this.setState({
      mergeDuration,
    });
  };

  handlePauseAllAudio = () => {
    this.setState({ playing: false });
    this.props.audioJoinerList.forEach(item => {
      if (item.wavesurfer && item.wavesurfer.isPlaying()) {
        item.wavesurfer.pause();
      }
    });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.audioJoinerList !== this.props.audioJoinerList) {
      console.log("xxx");
      this.handleMergeAudioDuration();
    }
  }

  render() {
    return (
      <div className="workplace-content">
        <div className="audio-joiner-list">
          {this.props.audioJoinerList.map((item, index) => (
            // <div key={item.guid}>
            <AudioJoinerWorkListItemFunction
              index={index}
              key={item.guid}
              audioJoinerItem={item}
              mergeDuration={this.state.mergeDuration}
              audioJoinerList={this.props.audioJoinerList}
              active={this.state.selectedIndex === index}
              handleSelected={() => this.handleSelected(index)}
              handlePlayFinishCallBack={() => this.handlePlayFinishCallBack(index)}
              handleAudioJoinerItemChange={this.props.handleAudioJoinerItemChange}
              handleChangeSort={this.handleChangeSort}
              handleDeleteAudioJoinerItem={guid => {
                this.handlePauseAllAudio();
                this.setState({ deleteGuid: guid, deleteModal: true });
              }}
              handleCurrentTimeFormItem={this.handleCurrentTimeFormItem}
              handlePauseAllAudio={this.handlePauseAllAudio}
              handleTimeChangeType={this.props.handleTimeChangeType}
            />
            // </div>
          ))}
        </div>
        <div className="track">
          {this.state.playing ? (
            <PauseIcon className="icon" onClick={this.tooglePlay} style={{ marginRight: 10 }} />
          ) : (
            <PlayIcon className="icon" onClick={this.tooglePlay} style={{ marginRight: 10 }} />
          )}

          <div className="active" style={{ width: "100%" }}>
            <Slider step={0.01} value={this.state.currentTimePercent} tipFormatter={null} onChange={this.handleCurrentTimeChange} />
          </div>
        </div>
        <TipsModalSimple
          visible={this.state.deleteModal}
          onCancel={() => {
            this.setState({ deleteModal: false });
          }}
          content="Are you sure you want to delete this task?"
          cancelBtnHandle={() => {
            this.setState({ deleteModal: false });
          }}
          confirmBtnHandle={this.handleDeleteAudioJoinerItem}
          confirmBtnText="YES"
        />
      </div>
    );
  }
}

export default AudioJoinerWorkContentFunction;
